import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";

const config = {
  apiKey: "AIzaSyC-sOEEwm_adZOjdwPrV3FYUPjmVlqq2rk",
  authDomain: "wangll-e694c.firebaseapp.com",
  databaseURL: "https://wangll-e694c.firebaseio.com",
  projectId: "wangll-e694c",
  storageBucket: "wangll-e694c.appspot.com",
  messagingSenderId: "1028677408308",
};
firebase.initializeApp(config);

// declare references
const db = firebase.firestore();
const firestore = firebase.firestore;
const auth = firebase.auth();
const fa = firebase.auth;
const functions = firebase.functions();

// firebase collections
const usersCollection = db.collection("users");
const companiesCollection = db.collection("companies");
const objectivesCollection = db.collection("objectives");
const keyResultsCollection = db.collection("keyResults");

export {
  db,
  fa,
  firestore,
  auth,
  functions,
  usersCollection,
  companiesCollection,
  objectivesCollection,
  keyResultsCollection,
};
